import { Injectable, inject } from "@angular/core";
import {
  Database,
  equalTo,
  listVal,
  orderByChild,
  query,
  ref,
  push,
  set,
  get,
} from "@angular/fire/database";
import { ICTema, IEmpresa } from "../../interfaces/catalogos.";
import {
  Observable,
  catchError,
  firstValueFrom,
  forkJoin,
  map,
  of,
  take,
  tap,
} from "rxjs";
import { EntradaService } from "../../entrada/entrada.service";
import { UsuarioService } from "../../usuario/usuario.service";
import { AcuerdoMrbService } from "../../acuerdo-mrb/acuerdo-mrb.service";
import { iCatalogos } from "../../entrada/entrada.interface";
import { sortCatalogo } from "../../utils";
import { AppState } from "../../app.state";
import { Store } from "@ngrx/store";
import { cargaCatalogos } from "../../states/catalogos/actions";
import { environment } from "../../../environments/environment";
import { HttpClient } from "@angular/common/http";
import {
  IRAplazarTema,
  IRAplazarTemaNotificacion,
} from "../../interfaces/acuerdos";

@Injectable({
  providedIn: "root",
})
export class TemasService {
  private database: Database = inject(Database);
  private entradaService = inject(EntradaService);
  private usuarioService = inject(UsuarioService);
  private acuerdoMrbService = inject(AcuerdoMrbService);
  public readonly store: Store<AppState> = inject(Store);

  constructor(private http: HttpClient) {}

  cargarTemas(): Observable<ICTema[]> {
    const refCatalogo = ref(this.database, "temas");
    const refQuery = query(refCatalogo, orderByChild("activo"), equalTo(true));
    return listVal(refQuery, { keyField: "id" });
  }

  async cargaCatalogos() {
    forkJoin({
      catTema: firstValueFrom(this.entradaService.getTemas()),
      catTipo: firstValueFrom(this.entradaService.getCatalogo("tipo")),
      catModoEntrada: firstValueFrom(
        this.entradaService.getCatalogo("modo_entrada")
      ),
      catPrioridad: firstValueFrom(
        this.entradaService.getCatalogo("prioridad")
      ),
      catEmpresa: firstValueFrom(this.entradaService.getCatalogo("empresa")),
      catRemitente: firstValueFrom(
        this.entradaService.getCatalogo("remitente")
      ),
      catEnvioAB: firstValueFrom(
        this.entradaService.getCatalogo("forma_envio")
      ),
      catFormaEnvio: firstValueFrom(
        this.acuerdoMrbService.getCatalogo(
          this.acuerdoMrbService.cats.TIPO_FORMA_ENVIO
        )
      ),
      catUsuarios: firstValueFrom(
        this.usuarioService.getUsuarios().pipe(
          map((users: any) =>
            users.map((item: any) => {
              item.temas_permiso = Object.keys(item.temas);
              return item;
            })
          )
        )
      ),
      catEntregable: firstValueFrom(
        this.entradaService.getCatalogo("entregable")
      ),
    }).subscribe({
      next: (oCatalogos: iCatalogos) => {
        oCatalogos.catEmpresa = sortCatalogo(
          oCatalogos.catEmpresa,
          "descripcion"
        );
        oCatalogos.catUsuarios = sortCatalogo(oCatalogos.catUsuarios, "nombre");
        oCatalogos.isloading = true;
        this.store.dispatch(cargaCatalogos({ oCatalogos }));
      },
      error: (msg) => console.error("Cargar Catalogos : ", msg),
    });
  }

  editarTemas(paylod: any): Observable<any> {
    return this.http.post<any>(`${environment.despacho.editarTemas}`, paylod).pipe(
      tap((data) => console.log("API Response", data)),
      take(1),
      map((data: any) => {
        return data;
      }),
      catchError((error) => {
        console.error("Error en downloadZIPFilesTemas", error);
        return of({ error: true });
      })
    );
  }

  nuevoTema(paylod: any): Observable<any> {
    return this.http
      .post<any>(`${environment.acuerdos.notificacion}/despacho/nuevoTema`, {
        ...paylod,
      })
      .pipe(
        tap((data) => console.log("API Response", data)),
        take(1),
        map((data: any) => {
          return { error: false, data };
        }),
        catchError((error) => {
          console.error("Error fetching acuerdos", error);
          return of({ error: true });
        })
      );
  }

  aplazarTema(aplazar: IRAplazarTema): Promise<any> {
    return firstValueFrom(
      this.http.post<any>(`${environment.acuerdos.aplazarTema}`, aplazar)
    );
  }

  aplazarTemaNotificacion(
    notificacion: IRAplazarTemaNotificacion
  ): Promise<any> {
    return firstValueFrom(
      this.http.post<any>(
        `${environment.acuerdos.notificacion}/mrb/${notificacion.notificacion}`,
        notificacion
      )
    );
  }
}
